import {FeedbackApi, type CreateFeedbackPayload, type FeedbackPayload} from '../api';
import {FetcherSettings} from '../api/apiClient';

class FeedbackService {
  private readonly feedbackApi: FeedbackApi;

  constructor() {
    this.feedbackApi = new FeedbackApi();
  }

  createFeedback(payload: CreateFeedbackPayload, resolverSettings?: FetcherSettings) {
    return this.feedbackApi.createFeedback(payload, resolverSettings);
  }
  createCheckoutFeedback(payload: FeedbackPayload, resolverSettings?: FetcherSettings) {
    return this.feedbackApi.createCheckoutFeedback(payload, resolverSettings);
  }
}

export {FeedbackService};
